import React from "react";
import { List } from "@refinedev/mui";
import { Tab, Tabs } from "@mui/material";
import { useSearchParams } from "react-router";
import { useTranslate } from "@refinedev/core";

import { CatalogTab } from "./tabs/Catalog";
import { EndpointsTab } from "./tabs/Endpoints";
import { ConfigsTab } from "./tabs/Configs";

const TABS = ["catalog", "endpoints", "configs"] as const;
type ErpIntegrationsTab = (typeof TABS)[number];

export const ErpIntegrations = React.memo(() => {
  const translate = useTranslate();
  const [searchParams, setSearchParams] = useSearchParams();

  const tabParam = searchParams.get("tab") as ErpIntegrationsTab | null;
  const tab: ErpIntegrationsTab =
    tabParam && (TABS as readonly string[]).includes(tabParam)
      ? tabParam
      : "catalog";

  return (
    <List title={translate("erp_integrations.erp_integrations")} headerButtons={<></>}>
      <Tabs
        value={tab}
        onChange={(_, value: ErpIntegrationsTab) => {
          setSearchParams((prev) => {
            const next = new URLSearchParams(prev);
            next.set("tab", value);
            return next;
          });
        }}
        variant="scrollable"
        sx={{ mb: 2 }}
      >
        {TABS.map((value) => (
          <Tab
            key={value}
            value={value}
            label={translate(`erp_integrations.tabs.${value}`)}
          />
        ))}
      </Tabs>

      {tab === "catalog" && <CatalogTab />}
      {tab === "endpoints" && <EndpointsTab />}
      {tab === "configs" && <ConfigsTab />}
    </List>
  );
});
